import styled from '@emotion/styled';
import { uiTheme as t } from 'Components/ui';

interface TextInputProps {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  /** Pinta el borde en rojo cuando el campo tiene un error de validación. */
  invalid?: boolean;
}

const Field = styled.input<{ invalid: boolean }>(({ invalid }) => ({
  width: '100%',
  // Estas pantallas no montan CssBaseline de MUI; sin border-box el 100% + padding
  // desborda la columna y los inputs del par (correo/teléfono) se solapan.
  boxSizing: 'border-box',
  padding: '11px 13px',
  border: `1px solid ${invalid ? t.color.danger : t.color.inputBorder}`,
  borderRadius: t.radius.sm,
  background: t.color.inputBg,
  fontFamily: t.font,
  fontSize: 14,
  color: t.color.title,
  outline: 'none',
  transition: 'border-color 0.15s ease',
  '&:focus': { borderColor: invalid ? t.color.danger : t.color.primary },
  '&::placeholder': { color: '#aab0b6' },
}));

/**
 * Primitivo de formulario: input de texto de una línea. Emite el valor ya
 * extraído del evento para que el consumidor no toque el DOM.
 */
const TextInput = ({ value, placeholder, onChange, onBlur, invalid = false }: TextInputProps) => (
  <Field
    value={value}
    placeholder={placeholder}
    onChange={e => onChange(e.target.value)}
    onBlur={onBlur}
    invalid={invalid}
  />
);

export default TextInput;
